module.exports = __webpack_public_path__ + "img/icon39.a6be2a72.png";